import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm" data-testid="auth-loading">Checking session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;

  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <div className="text-slate-700 text-sm" data-testid="access-denied">
          Access denied. Required role: {roles.join(", ")}.
        </div>
      </div>
    );
  }
  return children;
}
